import { Routes } from '@angular/router';
// Third party packages
// Custom packages - Misc
import { RoleGuard } from 'src/app/shared/guards/role.guard';
// Custom packages - Component
import { AddInterventionComponent } from 'src/app/modules/interventions/pages/add-intervention/add-intervention.page';
import { InterventionDetailComponent } from 'src/app/modules/interventions/pages/intervention-detail/intervention-detail.page';
import { InterventionsListComponent } from 'src/app/modules/interventions/pages/interventions-list/interventions-list.page';
var ɵ0 = {
    permissions: ['canReadInterventionsList'],
    roles: ['master', 'collaborator'],
}, ɵ1 = {
    permissions: ['canCreateInterventions'],
    roles: ['master', 'collaborator'],
}, ɵ2 = {
    permissions: ['canCreateInterventions'],
    roles: ['master', 'collaborator'],
};
var routes = [
    {
        path: 'list',
        component: InterventionsListComponent,
        canActivate: [RoleGuard],
        data: ɵ0,
    },
    {
        path: 'detail/:interventionId',
        component: InterventionDetailComponent,
        canActivate: [RoleGuard],
        data: ɵ1,
    },
    {
        path: 'add',
        component: AddInterventionComponent,
        canActivate: [RoleGuard],
        data: ɵ2,
    },
    {
        path: '**',
        redirectTo: 'it/errors/404'
    }
];
var InterventionsRoutingModule = /** @class */ (function () {
    function InterventionsRoutingModule() {
    }
    return InterventionsRoutingModule;
}());
export { InterventionsRoutingModule };
export { ɵ0, ɵ1, ɵ2 };
